import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Dropdown, Tab, Nav, } from "react-bootstrap";
import { get_Gemstone_GetData_GemData, get_BlogSingleData } from '../../../store/actions/CommanAction';
import { useDispatch, useSelector } from 'react-redux';
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import swal from "sweetalert";
import DataTable from 'react-data-table-component';
import { customStyles } from '../Utility/Utility';
import { SET__Gemstone_ID } from '../../../store/Action_Types';
// import Modal from 'react-bootstrap/Modal';
import { Modal, Button } from "react-bootstrap";
import GemstoneAdd from './GemstoneAdd';

const GemstoneList = () => {


    const dispatch = useDispatch()
    const GemstoneGetDataGemData = useSelector((state) => state.feedBackReducer.GemstoneGetDataGemData);
    
    const customerID = Number(sessionStorage.getItem('ID'));
    const [IsActive, setIsActive] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [showGemstoneAddModal, setShowGemstoneAddModal] = useState(false);


 const [showCopyModal, setShowCopyModal] = useState(false);
 const [id,setId]=useState(0);
  const [copyData, setCopyData] = useState({
    HeadingDescription: "",
    originalPrice: "",
    Discount: "",
    CurrentPrice: "",
    GSTinfo: "",
    GSTAmt: "",
    TotalAmt: "",
    GemstoneID:""
  });


    useEffect(() => {
        if (IsActive) {
            dispatch(get_Gemstone_GetData_GemData('1'))
        } else {
            dispatch(get_Gemstone_GetData_GemData('0'))
        }
    }, [IsActive, IsActive]);

    const filterGemstoneData = GemstoneGetDataGemData?.filter(item => {
        const query = searchQuery ? searchQuery.toLocaleLowerCase() : '';
        return (
            (item.HeadingDescription && item.HeadingDescription.toLocaleLowerCase().includes(query)) ||
            (item.ShortDescription && item.ShortDescription.toLocaleLowerCase().includes(query))
        );
    });

    const handleAddAstrologerClick = (row) => {
        dispatch({ type: SET__Gemstone_ID, payload: row?.GemstoneID });
        setShowGemstoneAddModal(true);
    };

    const handleToggleStatusClick = async (GemstoneID, currentStatus, isActiveValue) => {
        const postData = {
            'GemstoneID': GemstoneID,
            'DeleteByUser': customerID,
            IsActive: !currentStatus ? '1' : '0',
        };
        await AddUpdate('Gemstone/Delete_Gemstone', postData);
        dispatch(get_Gemstone_GetData_GemData(currentStatus ? '1' : '0'));
        swal('Good job!', `Successfully ${isActiveValue === '1' ? 'Active' : 'Inactive'}`, "success");

    };

    const columns = [
         {
            name: 'Image1',
            cell: row => (
                <div className="concierge-bx d-flex align-items-center">
                    {
                        row.Image1 ? (
                            <img
                                className="me-3 rounded"
                                src={`https://${row.Image1.replace(/\\/g, "/")}`}
                                alt="User Avatar"
                            />
                        ) : (
                            <span className="me-3 rounded">No Photo</span>
                        )
                    }
                </div>
            ),
            sortable: true
        },
      {
  name: 'Heading',
  cell: row => {
    const truncatedHeading =
      row.HeadingDescription && row.HeadingDescription.length > 15
        ? row.HeadingDescription.substring(0, 15) + "..."
        : row.HeadingDescription;

    return (
      <div className="concierge-bx d-flex align-items-center">
        <div>
          <h5 className="fs-16 mb-0 text-nowrap">
            <Link
              to="/GemstoneAdd"
              onClick={() => {
                handleAddAstrologerClick(row);
              }}
              className="text-black"
              title={row.HeadingDescription} 
            >
              {truncatedHeading}
            </Link>
          </h5>
        </div>
      </div>
    );
  },
  sortable: true
}
,
       
        
        {
              name:"Category", selector:(row)=>row.Category, sortable:true
        },
       
        {
          name:"TotalPrice", selector:(row)=>row.TotalAmt, sortable:true
        },
         {
            name:"Is Homepage", selector:(row)=>row.IsHomePage?"True":"false", sortable:true
        },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.GemstoneID, true, '0');
                                }}>
                                Inactive
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            )
        },
          {
      name: "Copy",
      selector: (row) => (
        <button onClick={() => handleCopy(row)} className="btn btn-primary btn-sm">
          Copy
        </button>
      ),
      sortable: true,
    },

    ];

    const columns1 = [
        {
            name: 'Heading',
            cell: row => (
                <div className="concierge-bx d-flex align-items-center">
                    <div>
                        <h5 className="fs-16 mb-0 text-nowrap">
                            <Link
                                to={"/GemstoneAdd"}
                                onClick={() => {
                                    handleAddAstrologerClick(row);
                                }}
                                className="text-black"
                            >
                                {row.HeadingDescription}
                            </Link>
                        </h5>
                    </div>
                </div>
            ),
            sortable: true
        },
        {
            name: 'Image1',
            cell: row => (
                <div className="concierge-bx d-flex align-items-center">
                    {
                        row.Image1 ? (
                            <img
                                className="me-3 rounded"
                                src={`https://${row.Image1.replace(/\\/g, "/")}`}
                                alt="User Avatar"
                            />
                        ) : (
                            <span className="me-3 rounded">No Photo</span>
                        )
                    }
                </div>
            ),
            sortable: true
        },
    
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.GemstoneID, false, '1');
                                }}>
                                Activate
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            )
        }
    ];


 const handleCopy = (row) => {
    setCopyData({
      HeadingDescription: row.HeadingDescription || "",
      originalPrice: row.originalPrice || "",
      Discount: row.Discount || "",
      CurrentPrice: row.CurrentPrice || "",
      GSTinfo: row.GSTinfo || "",
      GSTAmt: row.GSTAmt || "",
      TotalAmt: row.TotalAmt || "",
      gemstoneID:row.GemstoneID || ""
    });
    setShowCopyModal(true);
  };


  const handleCopyChange = (e) => {
    const { name, value } = e.target;
    // setCopyData({ ...copyData, [name]: value });
     let updatedValue = { ...copyData, [name]: value };

 const originalPrice = parseFloat(updatedValue.originalPrice) || 0;
  const discount = parseFloat(updatedValue.Discount) || 0;
  const price = originalPrice - (originalPrice * discount) / 100;
  updatedValue.CurrentPrice = Math.round(price);

  const gstPercentage = parseFloat(updatedValue.GSTinfo) || 0;
  const gstAmt = (price * gstPercentage) / 100;
  updatedValue.GSTAmt = Math.round(gstAmt);

  updatedValue.TotalAmt = Math.round(price + gstAmt);

  setCopyData(updatedValue);



  };

 
  const handleCopySubmit = async() => {
    

   
    const res=await AddUpdate("Gemstone/GemStoneCopy", copyData);
    await  dispatch(get_Gemstone_GetData_GemData('1'))
   
    setShowCopyModal(false);
  };


    return (
        <>


            {/* )} */}
            <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Gemstone List</h2>
            <Tab.Container defaultActiveKey="All">
                <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
                    <div className="card-action coin-tabs mb-2">
                        <Nav variant="tabs">
                            <Nav.Item as="li" className="nav-item">
                                <Nav.Link
                                    className={`nav-link ${IsActive ? 'active' : ''}`}
                                    onClick={() => {
                                        setIsActive(true);
                                        setSearchQuery('');
                                    }}
                                >
                                    Active
                                </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li" className="nav-item">
                                <Nav.Link
                                    className={`nav-link ${!IsActive ? 'active' : ''}`}
                                    onClick={() => {
                                        setIsActive(false);
                                        setSearchQuery('');
                                    }}
                                >
                                    Inactive
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <div>
                        <Link to="/GemstoneAdd" onClick={(e) => { e.preventDefault(); handleAddAstrologerClick(null); }} className="btn btn-primary font-w600 mb-2 me-auto" > Add Gemstone
                        </Link>
                    </div>
                    <div className="input-group search-area text-end" >
                        <input
                            type="text"
                            style={{border:"2px solid #F7931E"}}
                            className={`form-control text-dark`}
                            placeholder="Search Gemstone"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        {/* <span className="input-group-text" >
                            <Link to={"#"}><i className="flaticon-381-search-2"></i></Link>
                        </span> */}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <Tab.Content>
                                    <Tab.Pane eventKey="All">
                                        <div className="table-responsive">
                                            {
                                                IsActive ?
                                                    <>
                                                        <DataTable
                                                            dense
                                                            data={filterGemstoneData}
                                                            columns={columns}
                                                            selectableRowsHighlight
                                                            highlightOnHover
                                                            pagination
                                                            persistTableHead={true}
                                                            noDataComponent={"There are no data to display"}
                                                            customStyles={customStyles}
                                                        />
                                                    </>
                                                    :
                                                    <>
                                                        <DataTable
                                                            dense
                                                            data={filterGemstoneData}
                                                            columns={columns1}
                                                            selectableRowsHighlight
                                                            pagination
                                                            persistTableHead={true}
                                                            noDataComponent={"There are no data to display"}
                                                            customStyles={customStyles}

                                                        />
                                                    </>
                                            }
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </div>
                </div>


            </Tab.Container >

            <Modal
                show={showGemstoneAddModal}
                onHide={() => setShowGemstoneAddModal(false)}
                size="xl"
                centered
                backdrop="static"
                keyboard={false}
                className="custom-modal-centered border-0"
            >
                <Modal.Header closeButton>
                    <Modal.Title> <h2 className="heading mb-0">Add Gemstone</h2></Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto ' }}>
                    <GemstoneAdd 
                    
                    onClose={() => setShowGemstoneAddModal(false)} 
                    modalOpen={showGemstoneAddModal}
                    />
                </Modal.Body>
            </Modal>



 <Modal show={showCopyModal} onHide={() => setShowCopyModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Copy Gemstone</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="form-group mb-3 col-6">
              <label className="text-black font-w500">
                Gemstone Name<span className="text-danger star-error">*</span>
              </label>
              <input
                type="text"
                name="HeadingDescription"
                value={copyData.HeadingDescription}
                onChange={handleCopyChange}
                placeholder="Gemstone Name"
              />
            </div>

            <div className="form-group mb-3 col-4">
              <label className="text-black font-w500">Price (₹)</label>
              <input
                type="number"
                name="originalPrice"
                value={copyData.originalPrice}
                onChange={handleCopyChange}
                placeholder="Enter price"
              />
            </div>

            <div className="form-group mb-3 col-4">
              <label className="text-black font-w500">Discount (%)</label>
              <input
                type="number"
                name="Discount"
                value={copyData.Discount}
                onChange={handleCopyChange}
                placeholder="Enter discount"
              />
            </div>

            <div className="form-group mb-3 col-4">
              <label className="text-black font-w500">Current Price</label>
              <input
                type="number"
                name="CurrentPrice"
                value={copyData.CurrentPrice}
                onChange={handleCopyChange}
                placeholder="Enter current price"
              />
            </div>

            <div className="form-group mb-3 col-4">
              <label className="text-black font-w500">GST Info</label>
              <input
                type="text"
                name="GSTinfo"
                value={copyData.GSTinfo}
                onChange={handleCopyChange}
                placeholder="Gst %"
              />
            </div>

            <div className="form-group mb-3 col-4">
              <label className="text-black font-w500">GST Amt</label>
              <input
                type="number"
                name="GSTAmt"
                value={copyData.GSTAmt}
                onChange={handleCopyChange}
                placeholder="GSTAmt"
              />
            </div>

            <div className="form-group mb-3 col-4">
              <label className="text-black font-w500">Total Amt</label>
              <input
                type="number"
                name="TotalAmt"
                value={copyData.TotalAmt}
                onChange={handleCopyChange}
                placeholder="TotalAmt"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCopyModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleCopySubmit}>Save </Button>
        </Modal.Footer>
      </Modal>





        </>
    )
}
export default GemstoneList;